import React, { useState, useEffect } from 'react';
import Layout from '../Component/Layout';
import { BiMap } from "react-icons/bi";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from "swiper/modules";
import 'swiper/swiper-bundle.css';
import 'swiper/css/navigation';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import REACT_APP_API_URL from '../utils/constant';
import { showToast } from '../helper/Toster';
import Instagram from '../assets/Image/instagram.png';
import Facebook from '../assets/Image/facebook.png';
import Twitter from '../assets/Image/twitter.png';
import Tiktok from "../assets/Image/tik-tok.png";
import Youtube from "../assets/Image/youtube.png";



import Image from "../assets/Image/user1.png";
import Swal from "sweetalert2";
import { useNavigate } from 'react-router-dom';

const CityDetails = () => {
    const { id } = useParams();
    const [explore, setExplore] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [imageLoaded, setImageLoaded] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchExploreDetails = async () => {
            try {
                const response = await axios.get(`${REACT_APP_API_URL}/explore/${id}`, {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("user")}`,
                    }
                });
                if (response.data.code === 200) {
                    setExplore(response.data.data);
                } else {
                    throw new Error(response.data.message || "Failed to fetch data");
                }
            } catch (error) {
                console.error('Error fetching explore details:', error);
                setError(error.message);
                showToast("Error loading explore details", "error");
            } finally {
                setLoading(false);
            }
        };

        fetchExploreDetails();
    }, [id]);

    const handleDelete = async () => {
        const confirmDelete = await Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
        });
    
        if (!confirmDelete.isConfirmed) return;
    
        try {
            const response = await axios.get(`${REACT_APP_API_URL}/delete-explore?id=${id}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem("user")}`
                }
            });
    
            if (response.data.code === 200) {
                showToast("Explore deleted successfully", "Explore deleted successfully");
                navigate("/explore");
            } else {
                showToast(response.data.message || "Failed to delete", "error");
            }
        } catch (error) {
            console.error("Error deleting explore:", error);
            showToast("Error deleting explore", "error");
        }
    };

    const handleImageLoad = () => {
        setImageLoaded(true);
    };
    const getSocialIcon = (link) => {
        if (link.includes('instagram')) return Instagram;
        if (link.includes('facebook')) return Facebook;
        if (link.includes('twitter')) return Twitter;
        if (link.includes('tiktok')) return Tiktok;
        if (link.includes('youtube')) return Youtube;
        return Instagram; // default fallback
    };

    if (loading) {
        return (
            <Layout>
                <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            </Layout>
        );
    }

    if (error) {
        return (
            <Layout>
                <div className="alert alert-danger text-center my-5">
                    {error}
                    <button
                        className="btn btn-primary ms-3"
                        onClick={() => window.location.reload()}
                    >
                        Retry
                    </button>
                </div>
            </Layout>
        );
    }

    if (!explore) {
        return (
            <Layout>
                <div className="alert alert-info text-center my-5">
                    Explore not found
                    <Link to="/explore" className="btn btn-primary ms-3">
                        Back to Explore
                    </Link>
                </div>
            </Layout>
        );
    }

    return (
        <Layout>
            <div className='d-flex align-items-center justify-content-between mb-4'>
                <Link to="/explore" className="btn btn-primary">Back</Link>
                <div className='d-flex align-items-center gap-2'>
                    <Link to={`/explore/detail/edit/${id}`} className='btn btn-outline-primary px-5'>Edit</Link>
                    <Link className='btn btn-outline-primary px-5 'onClick={handleDelete}>Delete</Link>
                </div>
            </div>

            <div className="row row-cols-1 row-cols-md-3 g-6 mb-12">
                <div className="col-lg-4 col-md-5">
                    <div className="card">
                        <Swiper
                            className='userevents'
                            navigation={true}
                            modules={[Navigation]}
                            spaceBetween={10}
                            breakpoints={{ 0: { slidesPerView: 1 } }}
                        >
                            {explore.images && explore.images.length > 0 ? (
                                explore.images.map((img, index) => (
                                    <SwiperSlide className="position-relative" key={index}>
                                        {!imageLoaded && (
                                            <div 
                                                className="shimmer-bg" 
                                                style={{ 
                                                    height: '300px', 
                                                    width: '100%',
                                                    borderRadius: '4px'
                                                }}
                                            ></div>
                                        )}
                                        <img
                                            className="card-img-top"
                                            src={img || Image}
                                            alt={`Explore ${index + 1}`}
                                            onError={(e) => {
                                                e.target.src = Image;
                                                setImageLoaded(true);
                                            }}
                                            onLoad={handleImageLoad}
                                            style={{ 
                                                height: '300px', 
                                                objectFit: 'cover',
                                                display: imageLoaded ? 'block' : 'none'
                                            }}
                                        />
                                    </SwiperSlide>
                                ))
                            ) : (
                                <SwiperSlide>
                                    <img
                                        className="card-img-top"
                                        src={Image}
                                        alt="Default"
                                        style={{ height: '300px', objectFit: 'cover' }}
                                    />
                                </SwiperSlide>
                            )}
                        </Swiper>

                        <div className="card-body p-5">
                            <div className='d-flex align-items-center justify-content-between mb-1'>
                                <h5 className="card-title m-0">{explore.trip_name}</h5>
                                <p className='m-0 text-dark fw-medium'>({explore.category})</p>
                            </div>
                            <p className="card-text mb-2">{explore.description}</p>
                            <p className="card-text">
                                <BiMap className='bx' />
                                {explore.location}
                            </p>
                        </div>
                    </div>
                </div>

                <div className="col-lg-8 col-md-7">
                    <div className="card">
                        <div className="card-body">
                            {/* Clubs Section */}
                            <div className="stay mb-5">
                                <h5 className="mb-2">Clubs</h5>
                                <ul className="p-0 m-0 d-flex flex-wrap gap-3 align-items-start">
                                    {explore.clubs && explore.clubs.length > 0 ? (
                                        explore.clubs.map((club, index) => (
                                            <React.Fragment key={club.id}>
                                                <li className="light-bg">
                                                    {club.name}
                                                </li>
                                                {club.subClubs && club.subClubs.map(subClub => (
                                                    <li className="light-bg" key={subClub.id}>
                                                        {subClub.description}
                                                    </li>
                                                ))}
                                            </React.Fragment>
                                        ))
                                    ) : (
                                        <li className="text-muted">No clubs available</li>
                                    )}
                                </ul>
                            </div>

                            {/* Stays Section */}
                            <div className="stay mb-5">
                                <h5 className="mb-2">Stays</h5>
                                <ul className="p-0 m-0 d-flex flex-wrap gap-3 align-items-start">
                                    {explore.stays && explore.stays.length > 0 ? (
                                        explore.stays.map((stay, index) => (
                                            <li className="light-bg" key={stay.id}>
                                                {stay.description}
                                            </li>
                                        ))
                                    ) : (
                                        <li className="text-muted">No stays available</li>
                                    )}
                                </ul>
                            </div>

                            {/* Activities Section */}
                            <div className="stay mb-5">
                                <h5 className="mb-2">Additional Activities</h5>
                                <ul className="p-0 m-0 d-flex flex-wrap gap-3 align-items-start">
                                    {explore.activities && explore.activities.length > 0 ? (
                                        explore.activities.map((activity, index) => (
                                            <li className="light-bg" key={activity.id}>
                                                {activity.description}
                                            </li>
                                        ))
                                    ) : (
                                        <li className="text-muted">No activities available</li>
                                    )}
                                </ul>
                            </div>

                            {/* Social Links Section */}
                            <div className="stay mb-5">
                                <h5 className="mb-2">Social Links</h5>
                                <ul className="p-0 m-0 d-flex flex-wrap gap-3 align-items-start">
                                    {explore.socialLinks && explore.socialLinks.length > 0 ? (
                                        explore.socialLinks.map((link) => (
                                            <li className="light-bg d-flex align-items-center" key={link.id}>
                                                <img
                                                    src={getSocialIcon(link.link)}
                                                    className="me-2"
                                                    alt="social"
                                                    width={22}
                                                    height={22}
                                                />
                                                <a
                                                    href={link.link}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ color: '#646e78' }}
                                                >
                                                    {link.link}
                                                </a>
                                            </li>
                                        ))
                                    ) : (
                                        <li className="text-muted">No social links available</li>
                                    )}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <style>
                {`
                    .shimmer-bg {
                        background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
                        background-size: 200% 100%;
                        animation: shimmer 1.5s infinite;
                    }
                    
                    @keyframes shimmer {
                        0% { background-position: -200% 0; }
                        100% { background-position: 200% 0; }
                    }
                `}
            </style>
        </Layout>
    );
};

export default CityDetails;